module.exports = "<ng-container *ngIf=\"(auth.user() | async)?.tenant_scope\">\n    <div class=\"header-inner\" *can=\"'entities.work_log.write'\">\n        <button class=\"btn btn-primary\" (click)=\"open()\">\n            <i class=\"far fa-clock text-white\"></i><span class=\"visible-lg visible-md pull-right\"> {{ 'New time registration' | translate }}</span>\n        </button>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./apps/eyewatch/src/app/eyewatch/work-logs/plugins/add-work-log/add-work-log.plugin.html
// module id = ./apps/eyewatch/src/app/eyewatch/work-logs/plugins/add-work-log/add-work-log.plugin.html
// module chunks = main